// extracted by mini-css-extract-plugin
module.exports = {"check-points-wrapper":"check-points-wrapper__2RPWl","check-points-header":"check-points-header__2JtDz"};